/* PIP template only. Both purchase cards share one Buy 1 / Buy 2 Get 1 / Buy 3 Get 2 flow. */
(() => {
  'use strict';
  if (window.PIPLifePage) { window.PIPLifePage.init(document); return; }
  const controllers = new Set();
  let checkoutBusy = false;
  let checkoutUncertain = false;
  let checkoutNavigating = false;
  const refreshAll = () => controllers.forEach(controller => {
    if (controller.root.isConnected) controller.refresh();
  });
  const motion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const safeJson = element => { try { return JSON.parse(element.textContent); } catch (_) { return null; } };
  // Navigate through a real link click. Checkout apps (Revley) intercept link
  // clicks to /checkout; browsers do not let them patch location.assign.
  function navigateTo(url) {
    const link = document.createElement('a');
    link.href = url;
    link.hidden = true;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
  function initBuy(root) {
    if (root.dataset.pipReady) return;
    const data = safeJson(root.querySelector('[data-pip-product-data]'));
    if (!data || !data.variants.length) return;
    root.dataset.pipReady = 'true';
    const form = root.querySelector('form');
    const variantInput = form.elements.namedItem('id');
    const planInput = form.elements.namedItem('selling_plan');
    const submit = form.querySelector('[type="submit"]');
    const error = root.querySelector('[data-pip-error]');
    let activeVariant = null;

    let formatter;
    try { formatter = new Intl.NumberFormat(data.locale || 'en', {style:'currency', currency:data.currency}); }
    catch (_) { formatter = new Intl.NumberFormat('en', {style:'currency', currency:data.currency || 'USD'}); }
    const money = value => formatter.format(value / 100);
    function refreshDelivery() {
      root.querySelectorAll('[data-pip-delivery]').forEach(element => {
        const date = new Date();
        date.setDate(date.getDate() + (Number(element.dataset.days) || 3));
        element.textContent = date.toLocaleDateString(data.locale || 'en', {weekday:'long', month:'long', day:'numeric'});
      });
    }
    function refresh(sync) {
      const variant = data.variants.find(v => String(v.id) === String(variantInput.value));
      if (!variant) { submit.disabled = true; return; }
      if (activeVariant !== variant.id) {
        const previousPlan = planInput.value;
        planInput.replaceChildren();
        if (!data.requiresPlan) planInput.add(new Option('One-time purchase', ''));
        variant.plans.forEach(plan => planInput.add(new Option(`${plan.name} — ${money(plan.price)}`, String(plan.id))));
        if (Array.from(planInput.options).some(o => o.value === previousPlan)) planInput.value = previousPlan;
        activeVariant = variant.id;
      }
      planInput.disabled = !variant.plans.length;
      root.querySelector('.pip-plan-wrap').hidden = !variant.plans.length;
      const plan = variant.plans.find(p => String(p.id) === planInput.value);
      const price = plan ? plan.price : variant.price;
      const compare = plan ? plan.compare : variant.compare;
      const quantity = Number(form.querySelector('[name="quantity"]:checked').value);
      form.querySelectorAll('[name="quantity"]').forEach(radio => {
        radio.closest('.pip-pack').classList.toggle('is-selected', radio.checked);
      });
      root.querySelectorAll('[data-pip-gift]').forEach(card => {
        const locked = Number(card.dataset.pipGift) > quantity;
        card.classList.toggle('is-locked', locked);
        card.setAttribute('aria-disabled', String(locked));
        card.setAttribute('aria-label', `${card.dataset.giftName}: ${locked ? `locked. Choose Buy ${card.dataset.pipGift} to unlock.` : 'unlocked.'}`);
        card.querySelector('[data-pip-gift-label]').textContent = locked ? 'Locked' : card.dataset.giftName;
        card.querySelector('[data-pip-gift-lock]').hidden = !locked;
        const value = card.querySelector('[data-pip-gift-was]');
        if (value) { value.hidden = locked; value.textContent = money(price); }
      });
      const giftStatus = root.querySelector('[data-pip-gift-status]');
      if (giftStatus) giftStatus.textContent = quantity === 1 ? 'Free shipping unlocked.' : `Free shipping and ${quantity - 1} free ${quantity === 2 ? 'pouch' : 'pouches'} unlocked.`;
      root.querySelector('[data-pip-total]').textContent = money(price * quantity);
      root.querySelector('[data-pip-button-price]').textContent = money(price * quantity);
      const compareEl = root.querySelector('[data-pip-compare]');
      compareEl.hidden = quantity === 1;
      compareEl.textContent = money(price * (quantity * 2 - 1));
      root.querySelectorAll('[data-pip-pack-price]').forEach(el => { el.textContent = money(price * Number(el.dataset.pipPackPrice)); });
      root.querySelectorAll('[data-pip-pack-compare]').forEach(el => {
        el.hidden = !(compare > price);
        el.textContent = money(compare * Number(el.dataset.pipPackCompare));
      });
      const available = variant.available && (!data.requiresPlan || !!plan);
      form.querySelectorAll('[name="quantity"]').forEach(radio => { radio.disabled = checkoutBusy || checkoutUncertain; });
      if (variantInput.tagName === 'SELECT') variantInput.disabled = checkoutBusy || checkoutUncertain;
      if (checkoutBusy || checkoutUncertain) planInput.disabled = true;
      submit.disabled = checkoutBusy || checkoutUncertain || !available;
      submit.setAttribute('aria-busy', String(checkoutBusy));
      root.querySelector('[data-pip-button-label]').textContent = checkoutBusy ? 'Taking you to checkout…' : available ? 'Add to cart' : 'Sold out';
      if (sync) {
        controllers.forEach(other => {
          if (other.root !== root && other.root.isConnected && other.productId === data.productId) other.set(variant.id, quantity, planInput.value);
        });
      }
    }
    const controller = {root, productId:data.productId, refresh:() => refresh(false), refreshDelivery, set(id, quantity, plan) {
      if (!data.variants.some(v => String(v.id) === String(id))) return;
      variantInput.value = String(id);
      const radio = Array.from(form.querySelectorAll('[name="quantity"]')).find(r => Number(r.value) === quantity);
      if (radio) radio.checked = true;
      refresh(false);
      if (Array.from(planInput.options).some(o => o.value === plan)) planInput.value = plan;
      refresh(false);
    }};
    controllers.add(controller);
    form.addEventListener('change', () => { if (!checkoutUncertain) error.hidden = true; refresh(true); });
    refreshDelivery();
    root.querySelectorAll('[data-pip-gift]').forEach(card => card.addEventListener('click', () => {
      if (card.classList.contains('is-locked') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      card.querySelector('.pip-confetti')?.remove();
      const burst = document.createElement('span');
      burst.className = 'pip-confetti';
      burst.setAttribute('aria-hidden', 'true');
      for (let index = 0; index < 14; index++) {
        const piece = document.createElement('span');
        const angle = Math.PI * 2 * index / 14;
        const distance = 28 + Math.random() * 30;
        piece.style.setProperty('--dx', `${Math.cos(angle) * distance}px`);
        piece.style.setProperty('--dy', `${Math.sin(angle) * distance - 10}px`);
        piece.style.setProperty('--rot', `${Math.round(Math.random() * 360)}deg`);
        burst.appendChild(piece);
      }
      card.appendChild(burst);
      window.setTimeout(() => burst.remove(), 850);
    }));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      // Keep the theme's delegated cart/drawer handlers away from this form.
      event.stopImmediatePropagation();
      if (checkoutBusy || checkoutUncertain || submit.disabled) return;
      error.hidden = true;
      const quantity = Number(form.querySelector('[name="quantity"]:checked').value);
      const freeQuantity = quantity - 1;
      const receivedQuantity = quantity + freeQuantity;
      const variant = data.variants.find(v => String(v.id) === String(variantInput.value));
      const selectedPlan = !planInput.disabled && planInput.value ? planInput.value : '';
      const selectedAllocation = variant.plans.find(p => String(p.id) === selectedPlan);
      const unitPrice = selectedAllocation ? selectedAllocation.price : variant.price;
      checkoutBusy = true;
      refreshAll();
      // A private marker lets us verify and, if needed, roll back only this
      // click's items. Existing items in the customer's cart are preserved.
      const offerId = `pip-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      // Shopify's Buy X Get Y only gives the free Y units as a one-time purchase,
      // so on a subscription the free pouches must be a separate one-time line.
      const items = selectedPlan && freeQuantity > 0
        ? [
            {id:variantInput.value, quantity, selling_plan:selectedPlan, properties:{
              _pip_offer:offerId, _pip_paid:String(quantity), _pip_free:'0'
            }},
            {id:variantInput.value, quantity:freeQuantity, properties:{
              _pip_offer:offerId, _pip_paid:'0', _pip_free:String(freeQuantity)
            }}
          ]
        : [{id:variantInput.value, quantity:receivedQuantity, selling_plan:selectedPlan || undefined, properties:{
            _pip_offer:offerId, _pip_paid:String(quantity), _pip_free:String(freeQuantity)
          }}];
      let safelyReverted = false;
      async function readCart() {
        const response = await fetch(data.cartUrl, {credentials:'same-origin', cache:'no-store', headers:{'Accept':'application/json'}});
        if (!response.ok) throw new Error('cart-reconciliation-unavailable');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error('cart-reconciliation-unavailable');
        return cart;
      }
      async function revertOffer(cart) {
        const offerLines = cart.items.filter(line => line.properties?._pip_offer === offerId);
        if (!offerLines.length) return true;
        if (offerLines.some(line => !line.key)) throw new Error('cart-reconciliation-unavailable');
        const updates = {};
        offerLines.forEach(line => { updates[line.key] = 0; });
        const response = await fetch(data.updateUrl, {
          method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({updates})
        });
        const reverted = await response.json().catch(() => ({}));
        return response.ok && Array.isArray(reverted.items) && !reverted.items.some(line => line.properties?._pip_offer === offerId);
      }
      async function removeExistingVariantLines() {
        const cart = await readCart();
        const stale = cart.items.filter(line => String(line.variant_id || line.id) === String(variant.id));
        if (!stale.length) return;
        if (stale.some(line => !line.key)) throw new Error('cart-reconciliation-unavailable');
        const updates = {};
        stale.forEach(line => { updates[line.key] = 0; });
        const response = await fetch(data.updateUrl, {
          method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({updates})
        });
        if (!response.ok) throw new Error('cart-reconciliation-unavailable');
      }
      try {
        // Leftover lines of this product would share the bundle discount and
        // break the offer total, so the bundle replaces them.
        await removeExistingVariantLines();
        const response = await fetch(data.addUrl, {
          method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items})
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) {
          // Shopify can add the remaining inventory even while returning 422.
          // Reconcile every rejected add before allowing another submission.
          safelyReverted = await revertOffer(await readCart());
          if (!safelyReverted) throw new Error('cart-reconciliation-unavailable');
          throw new Error(typeof result.description === 'string' ? result.description : 'This selection could not be added. Please check availability and try again.');
        }
        // Shopify may split a discounted variant into paid and discounted lines.
        // Check this offer's complete quantity and subtotal, not a particular line.
        const cart = await readCart();
        const offerLines = cart.items.filter(line => line.properties?._pip_offer === offerId);
        const validOffer = offerLines.length > 0 && offerLines.every(line =>
          String(line.variant_id || line.id) === String(variant.id) &&
          Number.isInteger(line.quantity) && line.quantity > 0 &&
          Number.isFinite(line.final_line_price) && line.final_line_price >= 0 &&
          (!selectedPlan || (line.properties?._pip_paid === '0'
            ? !line.selling_plan_allocation
            : String(line.selling_plan_allocation?.selling_plan?.id) === selectedPlan))
        ) && offerLines.reduce((total, line) => total + line.quantity, 0) === receivedQuantity &&
          offerLines.reduce((total, line) => total + line.final_line_price, 0) <= unitPrice * quantity;
        if (!validOffer) {
          safelyReverted = await revertOffer(cart);
          if (!safelyReverted) throw new Error('cart-reconciliation-unavailable');
          throw new Error('Your complete bundle offer could not be applied, so it was not added. Please contact us for help, or choose Buy 1.');
        }
        checkoutNavigating = true;
        navigateTo(data.checkoutUrl);
      } catch (failure) {
        checkoutNavigating = false;
        checkoutUncertain = !safelyReverted;
        error.textContent = checkoutUncertain
          ? 'We could not confirm your complete offer. Please contact us before trying again so we can check your order selection.'
          : failure.message;
        error.hidden = false;
        checkoutBusy = false;
        refreshAll();
      }
    });
    refresh(false);
  }
  function initGallery(root) {
    if (root.dataset.pipReady) return;
    root.dataset.pipReady = 'true';
    const track = root.querySelector('.pip-gallery-track');
    const slides = Array.from(track.children);
    const dots = Array.from(root.querySelectorAll('[data-pip-slide]'));
    let current = 0;
    const go = index => {
      const selected = Math.max(0, Math.min(slides.length - 1, index));
      if (slides[selected]) track.scrollTo({left:slides[selected].offsetLeft - slides[0].offsetLeft, behavior:motion()});
    };
    dots.forEach((dot, index) => dot.addEventListener('click', () => go(index)));
    root.querySelectorAll('[data-pip-gallery-step]').forEach(button => button.addEventListener('click', () => go((current + Number(button.dataset.pipGalleryStep) + slides.length) % slides.length)));
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(current + (event.key === 'ArrowRight' ? 1 : -1)); }
    });
    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const previous = current;
        current = slides.reduce((closest, slide, index) => Math.abs(slide.offsetLeft - slides[0].offsetLeft - track.scrollLeft) < Math.abs(slides[closest].offsetLeft - slides[0].offsetLeft - track.scrollLeft) ? index : closest, 0);
        dots.forEach((dot,index) => { if (index === current) dot.setAttribute('aria-current','true'); else dot.removeAttribute('aria-current'); });
        if (current !== previous && dots[current]) {
          const thumbnails = dots[current].parentElement;
          const selectedBounds = dots[current].getBoundingClientRect();
          const stripBounds = thumbnails.getBoundingClientRect();
          if (selectedBounds.left < stripBounds.left || selectedBounds.right > stripBounds.right) {
            thumbnails.scrollBy({left:selectedBounds.left - stripBounds.left - (stripBounds.width - selectedBounds.width) / 2, behavior:motion()});
          }
        }
        ticking = false;
      });
    }, {passive:true});
  }
  function init(scope) {
    controllers.forEach(controller => { if (!controller.root.isConnected) controllers.delete(controller); });
    scope.querySelectorAll('[data-pip-buy]').forEach(initBuy);
    scope.querySelectorAll('[data-pip-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-pip-carousel]').forEach(root => {
      if (root.dataset.pipReady) return;
      root.dataset.pipReady = 'true';
      const track = root.querySelector('.pip-carousel-track');
      root.querySelectorAll('[data-pip-step]').forEach(button => button.addEventListener('click', () => {
        const first = track.firstElementChild;
        if (first) track.scrollBy({left: Number(button.dataset.pipStep) * (first.getBoundingClientRect().width + 16), behavior:motion()});
      }));
    });
  }
  // Browsers can restore this page, including disabled form controls, after
  // Back from checkout. Only clear the busy state for a completed navigation;
  // an unresolved cart mutation must remain locked against duplicate adds.
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    if (checkoutNavigating && !checkoutUncertain) {
      checkoutNavigating = false;
      checkoutBusy = false;
    }
    controllers.forEach(controller => {
      if (controller.root.isConnected) controller.refreshDelivery();
    });
    refreshAll();
  });
  window.PIPLifePage = {init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', () => { controllers.forEach(c => { if (!c.root.isConnected) controllers.delete(c); }); });
})();
